import React, { Component } from "react";
import "./style.scss";
import { Helmet } from "react-helmet";

class Home extends Component {
  render() {
    return (
      <div className="page Home">
        <Helmet>
          <title>Tanguy HELLER</title>
        </Helmet>

        <div className="photo-wrapper">
          <img src="/images/moi_bg4.png" alt="my-face"></img>
        </div>

        {/* <h1>Home</h1> */}
        <br />

        <div className="section">
          <p>
            Bonjour et bienvenue sur le site personnel de <b>Tanguy HELLER</b>.
          </p>
          <p>
            Ici vous pourrez trouver beaucoup d'informations me concernant,
            rendez-vous dans la rubrique <a href="/formations">formations</a> ou
            <a href="/experiences"> expériences </a>
            pour en apprendre plus sur mon parcours.
          </p>
          <p>
            Je suis friand de jeux vidéos et de game design depuis petit, j'aime
            aussi raconter des histoires alors j'occupe mon temps libre avec des
            <a href="/projets"> projets</a> en tout genre autour de mes
            passions. Mon dernier gros projet en date a été la création d'une
            console dématérialisée et de jeux sur navigateur et smartphone.
          </p>
          <p>
            Je passe aussi beaucoup de temps derrière les fourneaux pour régaler
            ma famille ou des amis retrouvés autour de jeux de plateau et autre
            geekeries.
          </p>
          <p>
            eMail: tanguy.heller@gmail.com <br />
            portable: 07.82.33.93.44
          </p>
        </div>
      </div>
    );
  }
}

export default Home;
